import useAdminPageURL from '../../hooks/useAdminPageURL';

export type TimelineBackTarget = 'appointments' | 'patient' | 'cases';

export const timelineBackTargets: TimelineBackTarget[] = ['appointments', 'patient', 'cases'];

export const isTimelineBackTarget = (value: unknown): value is TimelineBackTarget =>
  typeof value === 'string' && (timelineBackTargets as string[]).includes(value);

export const timelineBackQueryParam = (target: TimelineBackTarget) => ({ from: target });

export const useTimelineBackURL = () => {
  const { getAppointmentsPageURL, getCasesPageURL, getPatientsPageURL } = useAdminPageURL();

  return (target: TimelineBackTarget): string => {
    switch (target) {
      case 'appointments':
        return getAppointmentsPageURL();
      case 'cases':
        return getCasesPageURL();
      case 'patient':
        return getPatientsPageURL();
    }
  };
};